module.exports = __webpack_public_path__ + "img/salammall2.8aca1397.jpeg";